<template>
  <div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">{{ this.$route.meta.title }}</span>
      </h5>
    </div>
    <div class="card">
      <div class="card-header card-header-flex">
        <report v-bind="sentDataSearch"></report>
      </div>
      <div class="card-body">
        <div class="card-header card-header-flex">
          <div class="d-flex flex-column justify-content-center mr-auto">
            <b-dropdown variant="Clear" text="Export ข้อมูล" class="mb-3 mr-2">
              <b-dropdown-item
                type="button"
                v-clipboard:copy="JSON.stringify(this.selectedRowKeys)"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                ><i class="fa fa-copy mr-1" />Copy!
              </b-dropdown-item>
              <b-dropdown-item @click="checkDataExcel(json_data)">
                <download-excel
                  :data="json_data"
                  :fields="json_fields"
                  :name="getNameExport()"
                >
                  <i class="fa fa-file-excel-o mr-1" />Export Excel Select
                </download-excel>
              </b-dropdown-item>
              <b-dropdown-item>
                <download-excel
                  :data="dataExport"
                  :fields="json_fields"
                  :name="getNameExport()"
                >
                  <i class="fa fa-file-excel-o mr-1" />Export Excel All
                </download-excel>
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div
            class="d-flex flex-column justify-content-center"
            style="margin-inline: 5px"
          >
            <a
              class="btn btn-primary"
              href="javascript: void(0);"
              @click="getModelMange()"
              ><i class="fe fe-aperture mr-1" /> อัพเดทรายการ</a
            >
          </div>
          <div class="d-flex flex-column justify-content-center">
            <a
              class="btn btn-primary"
              href="javascript: void(0);"
              @click="getDataReport()"
              ><i class="fe fe-rotate-cw mr-1" /> รีเฟรช</a
            >
          </div>
        </div>
        <a-table
          :columns="columns"
          :dataSource="dataTable"
          :loading="isLoading"
          :row-selection="rowSelection"
          :pagination="false"
          rowKey="bankServiceId"
          :scroll="{ x: 1300 }"
        >
          <a
            slot="bankPaymentDeposit"
            slot-scope="text, record"
            :style="setColor('Deposit')"
            >{{ setComma(record.bankPaymentDeposit) }}</a
          >
          <a
            slot="bankPaymentWithdraw"
            slot-scope="text, record"
            :style="setColor('Withdraw')"
            >{{ setComma(record.bankPaymentWithdraw) }}</a
          >
          <a
            slot="lastSumBalance"
            slot-scope="text, record"
            :style="
              record.lastSumBalance < 0
                ? setColor('Withdraw')
                : setColor('Deposit')
            "
            >{{ setComma(record.lastSumBalance) }}</a
          >
          <a
            slot="TranferDeposit"
            slot-scope="text, record"
            :style="setColor('Withdraw')"
            >{{ setComma(record.TranferDeposit) }}</a
          >
          <a
            slot="TranferWithdraw"
            slot-scope="text, record"
            :style="setColor('Deposit')"
            >{{ setComma(record.TranferWithdraw) }}</a
          >
          <a
            slot="TranferDepositManual"
            slot-scope="text, record"
            :style="setColor('Withdraw')"
            >{{ setComma(record.TranferDepositManual) }}</a
          >
          <a
            slot="TranferWithdrawManual"
            slot-scope="text, record"
            :style="setColor('Deposit')"
            >{{ setComma(record.TranferWithdrawManual) }}</a
          >
          <a
            slot="depositReserveWithdrawal"
            slot-scope="text, record"
            :style="setColor('Deposit')"
            >{{ setComma(record.depositReserveWithdrawal) }}</a
          >
          <a
            slot="withdrawBankCenter"
            slot-scope="text, record"
            :style="setColor('Withdraw')"
            >{{ setComma(record.withdrawBankCenter) }}</a
          >
          <a
            slot="withdrawCustomer"
            slot-scope="text, record"
            :style="setColor('Withdraw')"
            >{{ setComma(record.withdrawCustomer) }}</a
          >
          <a
            slot="customerDepositFalse"
            slot-scope="text, record"
            :style="setColor('Deposit')"
            >{{ setComma(record.customerDepositFalse) }}</a
          >
          <a
            slot="interest"
            slot-scope="text, record"
            :style="setColor('Deposit')"
            >{{ setComma(record.interest) }}</a
          >
          <a
            slot="entryFee"
            slot-scope="text, record"
            :style="setColor('Withdraw')"
            >{{ setComma(record.entryFee) }}</a
          >
          <a
            slot="depositNotSpecified"
            slot-scope="text, record"
            :style="setColor('Deposit')"
            >{{ setComma(record.depositNotSpecified) }}</a
          >
          <a
            slot="withdrawNotSpecified"
            slot-scope="text, record"
            :style="setColor('Withdraw')"
            >{{ setComma(record.withdrawNotSpecified) }}</a
          >
          <a
            slot="sumBalance"
            slot-scope="text, record"
            :style="
              record.sumBalance < 0 ? setColor('Withdraw') : setColor('Deposit')
            "
            >{{ setComma(record.sumBalance) }}</a
          >
          <span slot="bankType" slot-scope="text">
            <a-tag v-if="text !== 99" :color="text === 1 ? 'green' : 'red'">
              {{
                text === 1
                  ? "บัญชีรับ"
                  : text === 2
                  ? "บัญชีถอน"
                  : text === 3
                  ? "บัญชีถอนคืนลูกค้า"
                  : text === 4
                  ? "บัญชีถอนคอมมิชชั่น"
                  : "ไม่พบข้อมํูล"
              }}
            </a-tag>
          </span>
        </a-table>
      </div>
    </div>
    <div class="card p-4">
      <div class="card">
      <div class="card-header card-header-flex">
        <div class="d-flex flex-column justify-content-center mr-auto">
          <h5>สรุปรายงาน</h5>
        </div>
        <div class="d-flex flex-column justify-content-center">
          <a
            class="btn btn-primary"
            href="javascript: void(0);"
            @click="setDateReport()"
            ><i class="fe fe-rotate-cw mr-1" /> รีเฟรช</a
          >
        </div>
      </div>
      <div class="card-body">
        <b-row>
          <b-col cols="12" md="6"
            ><b-form-group label-cols-sm="3" label="เลือกวันที่" class="mb-2">
              <b-row>
                <b-col cols="12" md="6">
                  <a-config-provider :locale="locale">
                    <a-date-picker
                      v-model="startDateReport"
                      :disabled-date="disabledStartDate"
                      format="YYYY-MM-DD"
                      placeholder="Start Date"
                      style="width: 100%"
                      @openChange="handleStartOpenChange"
                      @change="setDateReport"
                    />
                  </a-config-provider>
                </b-col>
                <b-col cols="12" md="6">
                  <a-config-provider :locale="locale">
                    <a-date-picker
                      v-model="endDateReport"
                      :disabled-date="disabledEndDate"
                      format="YYYY-MM-DD"
                      placeholder="End Date"
                      :open="endOpen"
                      style="width: 100%"
                      @openChange="handleEndOpenChange"
                      @change="setDateReport"
                    />
                  </a-config-provider>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="6" md="12">
            <b-col>
              <b-form-group label-cols-sm="3" label="คู่ค้า" class="mb-0">
                <a-select
                  v-model="operterReport"
                  show-search
                  placeholder="กรุณาเลือกข้อมูล"
                  style="width: 100%"
                  @select="setOperatorReport"
                >
                  <a-select-option value=""> กรุณาเลือกข้อมูล </a-select-option>
                  <a-select-option
                    v-for="(item, index) in operator"
                    :key="index"
                    :value="item.operatorCode"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </b-form-group>
            </b-col>
          </b-col>
        </b-row>
        <hr />
        <div class="row justify-content-evenly" style="padding-left: 1rem;">
            <b-dropdown variant="Clear" text="Export ข้อมูล" class="mb-3 mr-2">
              <b-dropdown-item
                type="button"
                v-clipboard:copy="JSON.stringify(this.selectedRowKeysReport)"
                v-clipboard:success="onCopyReport"
                v-clipboard:error="onError"
                ><i class="fa fa-copy mr-1" />Copy!
              </b-dropdown-item>
              <b-dropdown-item @click="checkDataExcel(json_data_report)">
                <download-excel
                  :data="json_data_report"
                  :fields="json_fields_report"
                  :name="getNameExportReport()"
                >
                  <i class="fa fa-file-excel-o mr-1" />Export Excel Select
                </download-excel>
              </b-dropdown-item>
              <b-dropdown-item>
                <download-excel
                  :data="dataExporReport"
                  :fields="json_fields_report"
                  :name="getNameExportReport()"
                >
                  <i class="fa fa-file-excel-o mr-1" />Export Excel All
                </download-excel>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        <!-- Q change card component to dataTable  -->
        <div id="summary-table">
          <a-table
            :columns="sumColumns"
            :dataSource="dataReports"
            :loading="isLoadingSumReport"
            :row-selection="rowSelectionReport"
            :pagination="false"
            rowKey="sumReportDate"
            :scroll="{ x: 1300 }"
          >
            <a
              slot="sumBankPaymentDeposit"
              slot-scope="text, record"
              :style="setColor('Deposit')"
              >{{ setComma(record.sumBankPaymentDeposit) }}</a
            >
            <a
              slot="overDeposit"
              slot-scope="text, record"
              :style="setColor('Deposit')"
              >{{ setComma(record.overDeposit) }}</a
            >
            <a
              slot="brokenDeposit"
              slot-scope="text, record"
              :style="setColor('Deposit')"
              >{{ setComma(record.brokenDeposit) }}</a
            >
            <a
              slot="sumTotalDeposit"
              slot-scope="text, record"
              :style="setColor('Deposit')"
              >{{ setComma(record.sumTotalDeposit) }}</a
            >
            <a
              slot="depositReserveWithdrawal"
              slot-scope="text, record"
              :style="setColor('Yellow')"
              >{{ setComma(record.depositReserveWithdrawal) }}</a
            >
            <a
              slot="sumBankPaymentWithdraw"
              slot-scope="text, record"
              :style="setColor('Withdraw')"
              >{{ setComma(record.sumBankPaymentWithdraw) }}</a
            >
            <a
              slot="overWithdraw"
              slot-scope="text, record"
              :style="setColor('Withdraw')"
              >{{ setComma(record.overWithdraw) }}</a
            >
            <a
              slot="brokenWithdraw"
              slot-scope="text, record"
              :style="setColor('Withdraw')"
              >{{ setComma(record.brokenWithdraw) }}</a
            >
            <a
              slot="sumTotalWithdraw"
              slot-scope="text, record"
              :style="setColor('Withdraw')"
              >{{ setComma(record.sumTotalWithdraw) }}</a
            >
            <a
              slot="sumWithdrawCustomer"
              slot-scope="text, record"
              :style="setColor('Orange')"
              >{{ setComma(record.sumWithdrawCustomer) }}</a
            >

            <a
              slot="TranferDeposit"
              slot-scope="text, record"
              :style="setColor('Withdraw')"
              >{{ setComma(record.TranferDeposit) }}</a
            >
            <a
              slot="TranferWithdraw"
              slot-scope="text, record"
              :style="setColor('Deposit')"
              >{{ setComma(record.TranferWithdraw) }}</a
            >
            <a
              slot="TranferDepositManual"
              slot-scope="text, record"
              :style="setColor('Withdraw')"
              >{{ setComma(record.TranferDepositManual) }}</a
            >
            <a
              slot="TranferWithdrawManual"
              slot-scope="text, record"
              :style="setColor('Deposit')"
              >{{ setComma(record.TranferWithdrawManual) }}</a
            >
            <a
              slot="withdrawBankCenter"
              slot-scope="text, record"
              :style="setColor('Light Blue')"
              >{{ setComma(record.withdrawBankCenter) }}</a
            >

            <a
              slot="depositNotSpecified"
              slot-scope="text, record"
              :style="setColor('Purple')"
              >{{ setComma(record.depositNotSpecified) }}</a
            >
            <a
              slot="withdrawNotSpecified"
              slot-scope="text, record"
              :style="setColor('Withdraw')"
              >{{ setComma(record.withdrawNotSpecified) }}</a
            >
            <a
              slot="customerDepositFalse"
              slot-scope="text, record"
              :style="setColor('Pink')"
              >{{ setComma(record.customerDepositFalse) }}</a
            >
            <a
              slot="interest"
              slot-scope="text, record"
              :style="setColor('Purple')"
              >{{ setComma(record.interest) }}</a
            >
            <!-- Chang by Noom -->
            <a
              slot="entryFee"
              slot-scope="text, record"
              :style="setColor('Deposit')"
              >{{ setComma(record.entryFee) }}</a
            >
            <a
              slot="sumWithdrawJackport"
              slot-scope="text, record"
              :style="setColor('Orange')"
              >{{ setComma(record.sumWithdrawJackport) }}</a
            >
            <a
              slot="sumWithdrawJackportManual"
              slot-scope="text, record"
              :style="setColor('Orange')"
              >{{ setComma(record.sumWithdrawJackportManual) }}</a
            >
            <a
              slot="sumBalance"
              slot-scope="text, record"
              :style="setColor('Deposit')"
              >{{ setComma(record.sumBalance) }}</a
            >

            <!-- <span slot="bankType" slot-scope="text">
              <a-tag v-if="text !== 99" :color="text === 1 ? 'green' : 'red'">
                {{
                  text === 1
                    ? "บัญชีรับ"
                    : text === 2
                    ? "บัญชีถอน"
                    : text === 3
                    ? "บัญชีถอนคืนลูกค้า"
                    : text === 4
                    ? "บัญชีถอนคอมมิชชั่น"
                    : "ไม่พบข้อมํูล"
                }}
              </a-tag>
            </span> -->
          </a-table>
        </div>
      </div>
    </div>
      <div class="card">
        <div class="card-header card-header-flex">
          <div class="d-flex flex-column justify-content-center mr-auto">
            <h5>สเตรทเมนท์เงินเกิน</h5>
          </div>
        </div>
        <div class="card-body">
          <a-table :columns="columnsOver" :dataSource="dataOver" rowKey='bankPaymentId'
            :loading="isLoadingSumReport" :scroll="{ x: 1500 }" :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }">
            <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
              class="custom-filter-dropdown">
              <a-input v-ant-ref="c => searchInput = c" :placeholder="`Search ${column.dataIndex}`"
                :value="selectedKeys[0]" @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                @pressEnter="() => handleSearch(selectedKeys, confirm)"
                style="width: 188px; margin-bottom: 8px; display: block;" />
              <a-button type="primary" @click="() => handleSearch(selectedKeys, confirm)" size="small"
                style="width: 90px; margin-right: 8px">
                Search
              </a-button>
              <a-button @click="() => handleReset(clearFilters)" size="small" style="width: 90px">
                Reset
              </a-button>
            </div>
            <a-icon slot="filterIcon" slot-scope="filtered" type="search"
              :style="{ color: filtered ? '#108ee9' : undefined }" />
            <a slot="actionAmountInCome" slot-scope="text, record"
              :style="setColorAmount('amountIn')">{{setCommaString(record.amountInCome)}}</a>
            <a slot="actionAmountOutCome" slot-scope="text, record"
              :style="setColorAmount('amountOut')">{{setCommaString(record.amountOutCome)}}</a>
            <h6 slot="status" slot-scope="status, record">
              <b-badge href="#"
                :loading="isLoadingSumReport" pill :variant="getStatus('bankPayment',status).color">
                {{getStatus('bankPayment',status).name}}
              </b-badge>
              <b-badge v-if="record.createdBy !== null && record.moneyTranferSlip === null" href="#"
                :loading="isLoadingSumReport" pill :variant="getStatus('bankPaymentCreated',1).color">
                {{getStatus('bankPaymentCreated',1).name}} : {{record.bankPaymentTypeName}}</b-badge>
                <b-badge v-else-if="record.createdBy !== null && record.moneyTranferSlip !== null" href="#"
                :loading="isLoadingSumReport" pill :variant="getStatus('bankPaymentCreated',2).color">
                {{getStatus('bankPaymentCreated',2).name}} : {{record.bankPaymentTypeName}}</b-badge>
                <b-badge v-else-if="record.createdBy === null && record.moneyTranferSlip !== null" href="#"
                :loading="isLoadingSumReport" pill :variant="getStatus('bankPaymentCreated',3).color">
                {{getStatus('bankPaymentCreated',3).name}} : {{record.bankPaymentTypeName}}</b-badge>

            </h6>
          </a-table>
        </div>
      </div>
      <div class="card">
        <div class="card-header card-header-flex">
          <div class="d-flex flex-column justify-content-center mr-auto">
            <h5>สเตรทเมนท์เงินขาด</h5>
          </div>

        </div>
        <div class="card-body">
          <a-table :columns="columnsBroken" :dataSource="dataBroken" rowKey='bankPaymentId'
            :loading="isLoadingSumReport" :scroll="{ x: 1500 }" :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }">
            <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
              class="custom-filter-dropdown">
              <a-input v-ant-ref="c => searchInput = c" :placeholder="`Search ${column.dataIndex}`"
                :value="selectedKeys[0]" @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                @pressEnter="() => handleSearch(selectedKeys, confirm)"
                style="width: 188px; margin-bottom: 8px; display: block;" />
              <a-button type="primary" @click="() => handleSearch(selectedKeys, confirm)" size="small"
                style="width: 90px; margin-right: 8px">
                Search
              </a-button>
              <a-button @click="() => handleReset(clearFilters)" size="small" style="width: 90px">
                Reset
              </a-button>
            </div>
            <a-icon slot="filterIcon" slot-scope="filtered" type="search"
              :style="{ color: filtered ? '#108ee9' : undefined }" />
            <a slot="actionAmountInCome" slot-scope="text, record"
              :style="setColorAmount('amountIn')">{{setCommaString(record.amountInCome)}}</a>
            <a slot="actionAmountOutCome" slot-scope="text, record"
              :style="setColorAmount('amountOut')">{{setCommaString(record.amountOutCome)}}</a>
            <h6 slot="status" slot-scope="status, record">
              <b-badge href="#"
                :loading="isLoadingSumReport" pill :variant="getStatus('bankPayment',status).color">
                {{getStatus('bankPayment',status).name}}
              </b-badge>
              <b-badge v-if="record.createdBy !== null && record.moneyTranferSlip === null" href="#"
                :loading="isLoadingSumReport" pill :variant="getStatus('bankPaymentCreated',1).color">
                {{getStatus('bankPaymentCreated',1).name}} : {{record.bankPaymentTypeName}}</b-badge>
                <b-badge v-else-if="record.createdBy !== null && record.moneyTranferSlip !== null" href="#"
                :loading="isLoadingSumReport" pill :variant="getStatus('bankPaymentCreated',2).color">
                {{getStatus('bankPaymentCreated',2).name}} : {{record.bankPaymentTypeName}}</b-badge>
                <b-badge v-else-if="record.createdBy === null && record.moneyTranferSlip !== null" href="#"
                :loading="isLoadingSumReport" pill :variant="getStatus('bankPaymentCreated',3).color">
                {{getStatus('bankPaymentCreated',3).name}} : {{record.bankPaymentTypeName}}</b-badge>

            </h6>
          </a-table>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header card-header-flex">
        <div class="d-flex flex-column justify-content-center mr-auto">
          <h5>สเตรทเมนท์คล้ายกัน</h5>
        </div>
        <div class="d-flex flex-column justify-content-center">
          <a
            class="btn btn-primary"
            href="javascript: void(0);"
            @click="setDateStatement()"
            ><i class="fe fe-rotate-cw mr-1" /> รีเฟรช</a
          >
        </div>
      </div>
      <div class="card-body">
        <b-row>
          <b-col cols="12" md="6"
            ><b-form-group label-cols-sm="3" label="เลือกวันที่" class="mb-2">
              <b-row>
                <b-col cols="12" md="6">
                  <a-config-provider :locale="locale">
                    <a-date-picker
                      v-model="startDateStatement"
                      :disabled-date="disabledStartDateStatement"
                      format="YYYY-MM-DD"
                      placeholder="Start Date"
                      style="width: 100%"
                      @openChange="handleStartOpenChangeStatement"
                      @change="setDateStatement"
                    />
                  </a-config-provider>
                </b-col>
                <!-- <b-col cols="12" md="6">
                  <a-config-provider :locale="locale">
                    <a-date-picker
                      v-model="endDateStatement"
                      :disabled-date="disabledEndDateStatement"
                      format="YYYY-MM-DD"
                      placeholder="End Date"
                      :open="endOpenStatement"
                      style="width: 100%"
                      @openChange="handleEndOpenChangeStatement"
                      @change="setDateStatement"
                    />
                  </a-config-provider>
                </b-col> -->
              </b-row>
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="6" md="12">
            <b-col>
              <b-form-group label-cols-sm="3" label="คู่ค้า" class="mb-0">
                <a-select
                  v-model="operterStatement"
                  show-search
                  placeholder="กรุณาเลือกข้อมูล"
                  style="width: 100%"
                  @select="setOperatorStatement"
                >
                  <a-select-option value=""> กรุณาเลือกข้อมูล </a-select-option>
                  <a-select-option
                    v-for="(item, index) in operator"
                    :key="index"
                    :value="item.operatorCode"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </b-form-group>
            </b-col>
          </b-col>
        </b-row>
        <hr />

        <!-- Q statement report -->
        <div id="statement-table">
          <a-table :columns="columnsStatement" :dataSource="dataStatement" rowKey='bankPaymentId'
          :loading="isLoadingStatement" :scroll="{ x: 1500 }" :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }">
          <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
            class="custom-filter-dropdown">
            <a-input v-ant-ref="c => searchInput = c" :placeholder="`Search ${column.dataIndex}`"
              :value="selectedKeys[0]" @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(selectedKeys, confirm)"
              style="width: 188px; margin-bottom: 8px; display: block;" />
            <a-button type="primary" @click="() => handleSearch(selectedKeys, confirm)" size="small"
              style="width: 90px; margin-right: 8px">
              Search
            </a-button>
            <a-button @click="() => handleReset(clearFilters)" size="small" style="width: 90px">
              Reset
            </a-button>
          </div>
          <a-icon slot="filterIcon" slot-scope="filtered" type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }" />
          <a slot="actionAmountInCome" slot-scope="text, record"
            :style="setColorAmount('amountIn')">{{setCommaString(record.amountInCome)}}</a>
          <a slot="actionAmountOutCome" slot-scope="text, record"
            :style="setColorAmount('amountOut')">{{setCommaString(record.amountOutCome)}}</a>
          <h6 slot="status" slot-scope="status, record">
            <b-badge href="#"
              :loading="isLoadingSumReport" pill :variant="getStatus('bankPayment',status).color">
              {{getStatus('bankPayment',status).name}}
            </b-badge>
            <b-badge v-if="record.createdBy !== null && record.moneyTranferSlip === null" href="#"
              :loading="isLoadingSumReport" pill :variant="getStatus('bankPaymentCreated',1).color">
              {{getStatus('bankPaymentCreated',1).name}} : {{record.bankPaymentTypeName}}</b-badge>
              <b-badge v-else-if="record.createdBy !== null && record.moneyTranferSlip !== null" href="#"
              :loading="isLoadingSumReport" pill :variant="getStatus('bankPaymentCreated',2).color">
              {{getStatus('bankPaymentCreated',2).name}} : {{record.bankPaymentTypeName}}</b-badge>
              <b-badge v-else-if="record.createdBy === null && record.moneyTranferSlip !== null" href="#"
              :loading="isLoadingSumReport" pill :variant="getStatus('bankPaymentCreated',3).color">
              {{getStatus('bankPaymentCreated',3).name}} : {{record.bankPaymentTypeName}}</b-badge>

          </h6>
        </a-table>
        </div>
      </div>
    </div>
    <a-modal
      v-model="modelMange"
      title="จัดการ"
      ok-text="ยืนยัน"
      cancel-text="ยกเลิก"
      showCancelButton="false"
      @ok="useModalMange"
    >
      <a-form-model ref="ruleForm" :model="form" :rules="rules">
        <a-form-model-item label="วันที่" prop="date">
          <!-- <a-input v-model="form.selectDate" /> -->
          <a-date-picker
            v-model="form.date"
            format="YYYY-MM-DD"
            placeholder="วันที่"
            style="width: 100%"
          />
        </a-form-model-item>
        <!-- <a-form-model-item label="คู่ค้า" prop="operatorCode">
              <a-select v-model="form.operatorCode"  placeholder="กรุณาเลือกข้อมูล" @select="setOperator">
                <a-select-option value="">
                  กรุณาเลือกข้อมูล
                </a-select-option>
                <a-select-option v-for="(item , index) in operator" :key="index" :value="item.operatorCode">
                    {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item> -->
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import report from '@/components/system/table/search/report'
import apiClient from '@/services/api'
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
import moment from 'moment'
import thTH from 'ant-design-vue/es/locale/th_TH'
import 'moment/locale/th'
import momentTz from 'moment-timezone'
import { getName } from '@/utils/status'

// import sumBankPaymentDeposit from "./sumBankPaymentDeposit.vue";
// import overDeposit from "./overDeposit.vue";
// import brokenDeposit from "./brokenDeposit.vue";
// import sumTotalDeposit from "./sumTotalDeposit.vue";
// import sumBankPaymentWithdraw from "./sumBankPaymentWithdraw.vue";
// import sumWithdrawCustomer from "./sumWithdrawCustomer.vue";
// import sumTotalWithdraw from "./sumTotalWithdraw.vue";
// import TranferDeposit from "./TranferDeposit.vue";
// import TranferWithdraw from "./TranferWithdraw.vue";
// import TranferDepositManual from "./TranferDepositManual.vue";
// import TranferWithdrawManual from "./TranferWithdrawManual.vue";
// import withdrawBankCenter from "./withdrawBankCenter.vue";
// import customerDepositFalse from "./customerDepositFalse.vue";
// import interest from "./interest.vue";
// import depositNotSpecified from "./depositNotSpecified.vue";
// import withdrawNotSpecified from "./withdrawNotSpecified.vue";
// import sumBalance from "./sumBalance.vue";
// import sumWithdrawJackport from "./sumWithdrawJackport.vue";
// import overWithdraw from "./overWithdraw.vue";
// import brokenWithdraw from "./brokenWithdraw.vue";
// import sumWithdrawJackportManual from "./sumWithdrawJackportManual.vue";
// import depositReserveWithdrawal from "./depositReserveWithdrawal.vue";

moment.locale('th')
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
function CopyMe(TextToCopy) {
  var TempText = document.createElement('textarea')
  TempText.value = TextToCopy
  document.body.appendChild(TempText)
  TempText.select()
  document.execCommand('copy')
  document.body.removeChild(TempText)
}
export default {
  components: {
    report,
    // sumBankPaymentDeposit,
    // overDeposit,
    // brokenDeposit,
    // sumTotalDeposit,
    // sumBankPaymentWithdraw,
    // sumWithdrawCustomer,
    // sumTotalWithdraw,
    // TranferDeposit,
    // TranferWithdraw,
    // TranferDepositManual,
    // TranferWithdrawManual,
    // withdrawBankCenter,
    // customerDepositFalse,
    // interest,
    // depositNotSpecified,
    // withdrawNotSpecified,
    // sumBalance,
    // sumWithdrawJackport,
    // sumWithdrawJackportManual,
    // overWithdraw,
    // brokenWithdraw,
    // depositReserveWithdrawal,
  },
  computed: {
    ...mapGetters({
      getStartDate: 'getStartDate',
      getEndDate: 'getEndDate',
      getSelectOperator: 'getSelectOperator',
    }),
    sentDataSearch: function () {
      return {
        pageType: this.pageType,
      }
    },
    rowSelection() {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,

        selections: [
          {
            key: 'all-data',
            text: 'เลือกทั้งหมด',
            onSelect: () => {
              this.selectedRowKeys = this.dataTable.map((result) => {
                return result.bankServiceId
              })
            },
          },
          {
            key: 'del-data',
            text: 'ลบทั้งหมด',
            onSelect: () => {
              this.selectedRowKeys = []
            },
          },
        ],
        onSelection: this.onSelection,
      }
    },
    rowSelectionReport() {
      const { selectedRowKeysReport } = this
      return {
        selectedRowKeysReport,
        onChange: this.onSelectChangeReport,
        hideDefaultSelections: true,

        selections: [
          {
            key: 'all-data',
            text: 'เลือกทั้งหมด',
            onSelect: () => {
              this.selectedRowKeysReport = this.dataReports.map((result) => {
                return result.sumReportDate
              })
            },
          },
          {
            key: 'del-data',
            text: 'ลบทั้งหมด',
            onSelect: () => {
              this.selectedRowKeysReport = []
            },
          },
        ],
        onSelection: this.onSelection,
      }
    },
    sumBankPaymentDeposit: function () {
      return {
        data: this.dataReports,
      }
    },
    overDeposit: function () {
      return {
        data: this.dataReports,
      }
    },
    brokenDeposit: function () {
      return {
        data: this.dataReports,
      }
    },
    sumTotalDeposit: function () {
      return {
        data: this.dataReports,
      }
    },
    sumBankPaymentWithdraw: function () {
      return {
        data: this.dataReports,
      }
    },
    sumWithdrawCustomer: function () {
      return {
        data: this.dataReports,
      }
    },
    sumTotalWithdraw: function () {
      return {
        data: this.dataReports,
      }
    },
    TranferDeposit: function () {
      return {
        data: this.dataReports,
      }
    },
    TranferWithdraw: function () {
      return {
        data: this.dataReports,
      }
    },
    withdrawBankCenter: function () {
      return {
        data: this.dataReports,
      }
    },
    customerDepositFalse: function () {
      return {
        data: this.dataReports,
      }
    },
    interest: function () {
      return {
        data: this.dataReports,
      }
    },
    depositNotSpecified: function () {
      return {
        data: this.dataReports,
      }
    },
    withdrawNotSpecified: function () {
      return {
        data: this.dataReports,
      }
    },
    sumWithdrawJackportManual: function () {
      return {
        data: this.dataReports,
      }
    },
    sumBalance: function () {
      return {
        data: this.dataReports,
        endDate: this.endDateReport,
      }
    },
    sumWithdrawJackport: function () {
      return {
        data: this.dataReports,
      }
    },
    brokenWithdraw: function () {
      return {
        data: this.dataReports,
      }
    },
    overWithdraw: function () {
      return {
        data: this.dataReports,
      }
    },
    TranferDepositManual: function () {
      return {
        data: this.dataReports,
      }
    },
    TranferWithdrawManual: function () {
      return {
        data: this.dataReports,
      }
    },
    depositReserveWithdrawal: function () {
      return {
        data: this.dataReports,
      }
    },
  },
  watch: {
    getStartDate: function (val) {
      if (val) {
        this.getDataReport()
      }
    },
    getEndDate: function (val) {
      if (val && !this.checkFistPage) {
        this.getDataReport()
      }

      if (this.checkFistPage) this.checkFistPage = false
    },
    getSelectOperator: function (val) {
      if (val) {
        this.getDataReport()
      }
    },
    selectedRowKeys: function (val) {
      if (val) {
        this.dataToExcel(val)
      }
    },
    selectedRowKeysReport: function (val) {
      if (val) {
        this.dataToExcelReport(val)
      }
    },
  },
  data() {
    return {
      locale: thTH,
      checkFistPage: true,
      modelMange: false,
      pageType: 'reportBankPayment',
      startDateReport: moment(),
      endDateReport: moment(),
      operterReport: '',
      startDateStatement: moment(),
      endDateStatement: moment(),
      operterStatement: '',
      modelShowDetail: false,
      loadingModal: false,
      loadingActive: true,
      statusKey: 1,
      json_fields: {
        ชื่อบัญชี: 'bankServiceName',
        ประเภท: 'bankServiceType',
        ยกยอดเงิน: 'lastSumBalance',
        รับเงินจากลูกค้า: 'bankPaymentDeposit',
        โอนออกหาลูกค้า: 'bankPaymentWithdraw',
        โยกไปถอน: 'TranferDeposit',
        รับจากฝาก: 'TranferWithdraw',
        โยกในระบบมือ: 'TranferDepositManual',
        รับในระบบมือ: 'TranferWithdrawManual',
        รับเงินสำรองถอน: 'depositReserveWithdrawal',
        โยกทีมกดเงิน: 'withdrawBankCenter',
        ถอนเงินคืนลูกค้า: 'withdrawCustomer',
        ลูกค้าโอนผิด: 'customerDepositFalse',
        ดอกเบี้ย: 'interest',
        ค่าธรรมเนียมเข้า: 'entryFee',
        ยอดเข้าไม่ระบุ: 'depositNotSpecified',
        ยอดถอนไม่ระบุ: 'withdrawNotSpecified',
        รวมคงเหลือ: 'sumBalance',
      },
      json_fields_report: {
        วันที่: 'sumReportDate',
        รวมเงินเข้าธนาคาร: 'sumBankPaymentDeposit',
        ยอดเติมเงินเกิน: 'overDeposit',
        ยอดเติมเงินขาด: 'brokenDeposit',
        ลูกค้าโอนผิด: 'customerDepositFalse',
        รวมยอดเติมเงิน: 'sumTotalDeposit',
        ยอดสำรองเงินถอน: 'depositReserveWithdrawal',
        รวมเงินออกธนาคาร: 'sumBankPaymentWithdraw',
        สรุปถอนเงินเกิน: 'overWithdraw',
        สรุปถอนเงินขาด: 'brokenWithdraw',
        ยอดถอนเงินคืนลูกค้า: 'sumWithdrawCustomer',
        รวมยอดถอนเงิน: 'sumTotalWithdraw',
        โยกไปถอน: 'TranferDeposit',
        รับจากฝาก: 'TranferWithdraw',
        โยกไปถอนมือ: 'TranferDepositManual',
        รับจากฝากมือ: 'TranferWithdrawManual',
        โยกทีมกดเงิน: 'withdrawBankCenter',
        ยอดเข้าไม่ระบุ: 'depositNotSpecified',
        ยอดถอนไม่ระบุ: 'withdrawNotSpecified',
        ดอกเบี้ย: 'interest',
        สรุปยอดรวมถอนเงินJackport: 'sumWithdrawJackport',
        สรุปยอดรวมถอนเงินJackportนอกระบบ: 'sumWithdrawJackportManual',
        ยอดเงินคงเหลือในบัญชีวันที่สุดท้ายที่เหลือ: 'sumBalance',
      },
      columns: [
        {
          title: 'ชื่อบัญชี',
          key: 'bankServiceName',
          dataIndex: 'bankServiceName',
          width: 280,
        },
        {
          title: 'ประเภท',
          dataIndex: 'bankServiceType',
          key: 'bankServiceType',
          filters: [
            { text: 'บัญชีรับ', value: 1 },
            { text: 'บัญชีถอน', value: 2 },
            { text: 'บัญชีถอนคืนลูกค้า', value: 3 },
            { text: 'บัญชีถอนคอมมิชชั่น', value: 4 },
          ],
          onFilter: (value, record) =>
            record.bankServiceType.toString().includes(value.toString()),
          width: 120,
          scopedSlots: { customRender: 'bankType' },
        },
        {
          title: 'ยกยอดเงิน',
          key: 'lastSumBalance',
          dataIndex: 'lastSumBalance',
          scopedSlots: { customRender: 'lastSumBalance' },
          width: 120,
        },
        {
          title: 'รับเงินจากลูกค้า',
          key: 'bankPaymentDeposit',
          dataIndex: 'bankPaymentDeposit',
          scopedSlots: { customRender: 'bankPaymentDeposit' },
          width: 120,
        },
        {
          title: 'โอนออกหาลูกค้า',
          key: 'bankPaymentWithdraw',
          dataIndex: 'bankPaymentWithdraw',
          scopedSlots: { customRender: 'bankPaymentWithdraw' },
          width: 120,
        },
        {
          title: 'โยกไปถอน',
          key: 'TranferDeposit',
          dataIndex: 'TranferDeposit',
          scopedSlots: { customRender: 'TranferDeposit' },
          width: 120,
        },
        {
          title: 'รับจากฝาก',
          key: 'TranferWithdraw',
          dataIndex: 'TranferWithdraw',
          scopedSlots: { customRender: 'TranferWithdraw' },
          width: 120,
        },
        {
          title: 'โยกในระบบมือ',
          key: 'TranferDepositManual',
          dataIndex: 'TranferDepositManual',
          scopedSlots: { customRender: 'TranferDepositManual' },
          width: 120,
        },
        {
          title: 'รับในระบบมือ',
          key: 'TranferWithdrawManual',
          dataIndex: 'TranferWithdrawManual',
          scopedSlots: { customRender: 'TranferWithdrawManual' },
          width: 120,
        },
        {
          title: 'รับเงินสำรองถอน',
          key: 'depositReserveWithdrawal',
          dataIndex: 'depositReserveWithdrawal',
          scopedSlots: { customRender: 'depositReserveWithdrawal' },
          width: 120,
        },
        {
          title: 'โยกทีมกดเงิน',
          key: 'withdrawBankCenter',
          dataIndex: 'withdrawBankCenter',
          scopedSlots: { customRender: 'withdrawBankCenter' },
          width: 120,
        },
        {
          title: 'ถอนเงินคืนลูกค้า',
          key: 'withdrawCustomer',
          dataIndex: 'withdrawCustomer',
          scopedSlots: { customRender: 'withdrawCustomer' },
          width: 120,
        },
        {
          title: 'ลูกค้าโอนผิด',
          key: 'customerDepositFalse',
          dataIndex: 'customerDepositFalse',
          scopedSlots: { customRender: 'customerDepositFalse' },
          width: 120,
        },
        {
          title: 'ดอกเบี้ย',
          key: 'interest',
          dataIndex: 'interest',
          scopedSlots: { customRender: 'interest' },
          width: 120,
        },
        {
          title: 'ค่าธรรมเนียมเข้า',
          key: 'entryFee',
          dataIndex: 'entryFee',
          scopedSlots: { customRender: 'entryFee' },
          width: 120,
        },
        {
          title: 'ยอดเข้าไม่ระบุ',
          key: 'depositNotSpecified',
          dataIndex: 'depositNotSpecified',
          scopedSlots: { customRender: 'depositNotSpecified' },
          width: 120,
        },
        {
          title: 'ยอดถอนไม่ระบุ',
          key: 'withdrawNotSpecified',
          dataIndex: 'withdrawNotSpecified',
          scopedSlots: { customRender: 'withdrawNotSpecified' },
          width: 120,
        },
        {
          title: 'รวมคงเหลือ',
          key: 'sumBalance',
          dataIndex: 'sumBalance',
          scopedSlots: { customRender: 'sumBalance' },
          width: 120,
        },
      ],
      columnsBroken: [
        {
          title: 'ลำดับ',
          key: 'bankPaymentId',
          dataIndex: 'bankPaymentId',
          width: 80,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'bankPaymentId',
          },
          onFilter: (value, record) => record.bankPaymentId.toString().includes(value.toString()),
        },
        {
          title: 'ชื่อคู่ค้า',
          key: 'operatorName',
          dataIndex: 'operatorName',
          width: 100,
          filters: [],
          onFilter: (value, record) => record.operatorName.toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: 'บัญชีระบบ',
          key: 'bankServiceSystem',
          dataIndex: 'bankServiceSystem',
          width: 150,
        },
        {
          title: 'เวลาโอน',
          key: 'datetimeTranfer',
          dataIndex: 'datetimeTranfer',
          sorter: (a, b) => { return new Date(a.datetimeTranfer) - new Date(b.datetimeTranfer) },
          customRender: (text, row, index) => {
            return momentTz(text).tz('utc').format('DD/MM/YYYY HH:mm:ss')
          },
          width: 150,
        },
        {
          title: 'เงินเข้า',
          key: 'amountInCome',
          dataIndex: 'amountInCome',
          sorter: (a, b) => a.amountInCome - b.amountInCome,
          scopedSlots: { customRender: 'actionAmountInCome' },
          // customRender: (text, row, index) => {
          //   if (text !== '-') {
          //     const amountIncomes = parseFloat(text)
          //     return amountIncomes.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          //   }
          //   return text
          // },
          width: 100,
        },
        {
          title: 'เงินออก',
          key: 'amountOutCome',
          dataIndex: 'amountOutCome',
          scopedSlots: { customRender: 'actionAmountOutCome' },
          // customRender: (text, row, index) => {
          //   if (text !== '-') {
          //     const amountOutComes = parseFloat(text)
          //     return amountOutComes.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          //   }
          //   return text
          // },
          width: 100,
        },
        {
          title: 'รายละเอียด',
          key: 'detail',
          dataIndex: 'detail',
          scopedSlots: {
            customRender: 'detail',
          },
          width: 100,
        },
        {
          title: 'สถานะ',
          filters: [],
          onFilter: (value, record) => record.filtersStatus.toString().includes(value.toString()),
          // onFilter: (value, record) => record.filtersStatus.toString().includes(value.toString()),
          key: 'status',
          dataIndex: 'bankPaymentStatus',
          scopedSlots: {
            customRender: 'status',
          },
          width: 130,
          fixed: 'right',
        },
        {
          title: 'ธนาคารที่โอน',
          key: 'detailBankNumber',
          dataIndex: 'detailBankNumber',
          width: 250,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'detailBankNumber',
          },
          onFilter: (value, record) => record.detailBankNumber.toLowerCase().includes(value.toLowerCase()),
          fixed: 'right',
        },
        {
          title: 'วันที่สร้าง',
          key: 'createdAt',
          dataIndex: 'createdAt',
          width: 100,
          customRender: (text, row, index) => {
            return momentTz(text).tz('utc').format('DD/MM/YYYY HH:mm:ss')
          },
          fixed: 'right',

        },
        {
          title: 'วันที่อัปเดท',
          key: 'updatedAt',
          dataIndex: 'updatedAt',
          width: 100,
          customRender: (text, row, index) => {
            return momentTz(text).tz('utc').format('DD/MM/YYYY HH:mm:ss')
          },
          fixed: 'right',

        },
      ],
      columnsOver: [
        {
          title: 'ลำดับ',
          key: 'bankPaymentId',
          dataIndex: 'bankPaymentId',
          width: 80,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'bankPaymentId',
          },
          onFilter: (value, record) => record.bankPaymentId.toString().includes(value.toString()),
        },
        {
          title: 'ชื่อคู่ค้า',
          key: 'operatorName',
          dataIndex: 'operatorName',
          width: 100,
          filters: [],
          onFilter: (value, record) => record.operatorName.toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: 'บัญชีระบบ',
          key: 'bankServiceSystem',
          dataIndex: 'bankServiceSystem',
          width: 150,
        },
        {
          title: 'เวลาโอน',
          key: 'datetimeTranfer',
          dataIndex: 'datetimeTranfer',
          sorter: (a, b) => { return new Date(a.datetimeTranfer) - new Date(b.datetimeTranfer) },
          customRender: (text, row, index) => {
            return momentTz(text).tz('utc').format('DD/MM/YYYY HH:mm:ss')
          },
          width: 150,
        },
        {
          title: 'เงินเข้า',
          key: 'amountInCome',
          dataIndex: 'amountInCome',
          sorter: (a, b) => a.amountInCome - b.amountInCome,
          scopedSlots: { customRender: 'actionAmountInCome' },
          // customRender: (text, row, index) => {
          //   if (text !== '-') {
          //     const amountIncomes = parseFloat(text)
          //     return amountIncomes.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          //   }
          //   return text
          // },
          width: 100,
        },
        {
          title: 'เงินออก',
          key: 'amountOutCome',
          dataIndex: 'amountOutCome',
          scopedSlots: { customRender: 'actionAmountOutCome' },
          // customRender: (text, row, index) => {
          //   if (text !== '-') {
          //     const amountOutComes = parseFloat(text)
          //     return amountOutComes.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          //   }
          //   return text
          // },
          width: 100,
        },
        {
          title: 'รายละเอียด',
          key: 'detail',
          dataIndex: 'detail',
          scopedSlots: {
            customRender: 'detail',
          },
          width: 100,
        },
        {
          title: 'สถานะ',
          filters: [],
          onFilter: (value, record) => record.filtersStatus.toString().includes(value.toString()),
          // onFilter: (value, record) => record.filtersStatus.toString().includes(value.toString()),
          key: 'status',
          dataIndex: 'bankPaymentStatus',
          scopedSlots: {
            customRender: 'status',
          },
          width: 130,
          fixed: 'right',
        },
        {
          title: 'ธนาคารที่โอน',
          key: 'detailBankNumber',
          dataIndex: 'detailBankNumber',
          width: 250,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'detailBankNumber',
          },
          onFilter: (value, record) => record.detailBankNumber.toLowerCase().includes(value.toLowerCase()),
          fixed: 'right',
        },
        {
          title: 'วันที่สร้าง',
          key: 'createdAt',
          dataIndex: 'createdAt',
          width: 100,
          customRender: (text, row, index) => {
            return momentTz(text).tz('utc').format('DD/MM/YYYY HH:mm:ss')
          },
          fixed: 'right',

        },
        {
          title: 'วันที่อัปเดท',
          key: 'updatedAt',
          dataIndex: 'updatedAt',
          width: 100,
          customRender: (text, row, index) => {
            return momentTz(text).tz('utc').format('DD/MM/YYYY HH:mm:ss')
          },
          fixed: 'right',

        },
      ],
      columnsDefDef: [
        {
          title: 'ธนาคาร',
          key: 'name',
          dataIndex: 'name',
          width: 120,
        },
        {
          title: 'เลขบัญชี',
          key: 'accountNumber',
          dataIndex: 'accountNumber',
          width: 120,
        },
        {
          title: 'ชื่อบัญชี',
          key: 'accountName',
          dataIndex: 'accountName',
          width: 120,
        },
        {
          title: 'รหัสสเตทเม้น',
          key: 'bankPaymentId',
          dataIndex: 'bankPaymentId',
          width: 120,
        },
        {
          title: 'รายละเอียดการโอน',
          key: 'detailBankNumber',
          dataIndex: 'detailBankNumber',
          width: 120,
        },
        {
          title: 'code',
          key: 'depositCode',
          dataIndex: 'depositCode',
          width: 120,
        },
        {
          title: 'วันที่เคลื่อน',
          key: 'updatedAt',
          dataIndex: 'updatedAt',
          customRender: (text, row, index) => {
            return moment(text).format('DD/MM/YYYY HH:mm:ss')
          },
          width: 120,
        },
        {
          title: 'จำนวนเงิน',
          key: 'amount',
          dataIndex: 'amount',
          width: 120,
        },
      ],
      sumColumns: [
        {
          title: 'วันที่',
          key: 'sumReportDate',
          dataIndex: 'sumReportDate',
          width: 100,
          fixed: 'left',
          sorter: (a, b) => moment(a.sumReportDate).unix() - moment(b.sumReportDate).unix(),
        },
        {
          title: 'รวมเงินเข้าธนาคาร',
          key: 'sumBankPaymentDeposit',
          dataIndex: 'sumBankPaymentDeposit',
          scopedSlots: { customRender: 'sumBankPaymentDeposit' },
          width: 120,
        },
        {
          title: 'ยอดเติมเงินเกิน',
          key: 'overDeposit',
          dataIndex: 'overDeposit',
          scopedSlots: { customRender: 'overDeposit' },
          width: 120,
        },
        {
          title: 'ยอดเติมเงินขาด',
          key: 'brokenDeposit',
          dataIndex: 'brokenDeposit',
          scopedSlots: { customRender: 'brokenDeposit' },
          width: 120,
        },
        {
          title: 'ลูกค้าโอนผิด',
          key: 'customerDepositFalse',
          dataIndex: 'customerDepositFalse',
          scopedSlots: { customRender: 'customerDepositFalse' },
          width: 120,
        },
        {
          title: 'รวมยอดเติมเงิน',
          key: 'sumTotalDeposit',
          dataIndex: 'sumTotalDeposit',
          scopedSlots: { customRender: 'sumTotalDeposit' },
          width: 120,
        },
        {
          title: 'ยอดสำรองเงินถอน',
          key: 'depositReserveWithdrawal',
          dataIndex: 'depositReserveWithdrawal',
          scopedSlots: { customRender: 'depositReserveWithdrawal' },
          width: 120,
        },
        {
          title: 'รวมเงินออกธนาคาร',
          key: 'sumBankPaymentWithdraw',
          dataIndex: 'sumBankPaymentWithdraw',
          scopedSlots: { customRender: 'sumBankPaymentWithdraw' },
          width: 120,
        },
        {
          title: 'สรุปถอนเงินเกิน',
          key: 'overWithdraw',
          dataIndex: 'overWithdraw',
          scopedSlots: { customRender: 'overWithdraw' },
          width: 120,
        },
        {
          title: 'สรุปถอนเงินขาด',
          key: 'brokenWithdraw',
          dataIndex: 'brokenWithdraw',
          scopedSlots: { customRender: 'brokenWithdraw' },
          width: 120,
        },
        {
          title: 'ยอดถอนเงินคืนลูกค้า',
          key: 'sumWithdrawCustomer',
          dataIndex: 'sumWithdrawCustomer',
          scopedSlots: { customRender: 'sumWithdrawCustomer' },
          width: 120,
        },
        {
          title: 'รวมยอดถอนเงิน',
          key: 'sumTotalWithdraw',
          dataIndex: 'sumTotalWithdraw',
          scopedSlots: { customRender: 'sumTotalWithdraw' },
          width: 120,
        },
        {
          title: 'โยกไปถอน',
          key: 'TranferDeposit',
          dataIndex: 'TranferDeposit',
          scopedSlots: { customRender: 'TranferDeposit' },
          width: 120,
        },
        {
          title: 'รับจากฝาก',
          key: 'TranferWithdraw',
          dataIndex: 'TranferWithdraw',
          scopedSlots: { customRender: 'TranferWithdraw' },
          width: 120,
        },
        {
          title: 'โยกไปถอนมือ',
          key: 'TranferDepositManual',
          dataIndex: 'TranferDepositManual',
          scopedSlots: { customRender: 'TranferDepositManual' },
          width: 120,
        },
        {
          title: 'รับจากฝากมือ',
          key: 'TranferWithdrawManual',
          dataIndex: 'TranferWithdrawManual',
          scopedSlots: { customRender: 'TranferWithdrawManual' },
          width: 120,
        },
        {
          title: 'โยกทีมกดเงิน',
          key: 'withdrawBankCenter',
          dataIndex: 'withdrawBankCenter',
          scopedSlots: { customRender: 'withdrawBankCenter' },
          width: 120,
        },
        {
          title: 'ยอดเข้าไม่ระบุ ',
          key: 'depositNotSpecified',
          dataIndex: 'depositNotSpecified',
          scopedSlots: { customRender: 'depositNotSpecified' },
          width: 120,
        },
        {
          title: 'ยอดถอนไม่ระบุ',
          key: 'withdrawNotSpecified',
          dataIndex: 'withdrawNotSpecified',
          scopedSlots: { customRender: 'withdrawNotSpecified' },
          width: 120,
        },
        {
          title: 'ดอกเบี้ย',
          key: 'interest',
          dataIndex: 'interest',
          scopedSlots: { customRender: 'interest' },
          width: 120,
        },
        {
          title: 'สรุปยอดรวมถอนเงิน jackport',
          key: 'sumWithdrawJackport',
          dataIndex: 'sumWithdrawJackport',
          scopedSlots: { customRender: 'sumWithdrawJackport' },
          width: 120,
        },
        {
          title: 'สรุปยอดรวมถอนเงิน jackport นอกระบบ',
          key: 'sumWithdrawJackportManual',
          dataIndex: 'sumWithdrawJackportManual',
          scopedSlots: { customRender: 'sumWithdrawJackportManual' },
          width: 120,
        },
        {
          title: 'ยอดเงินคงเหลือในบัญชีวันที่ สุดท้ายที่เหลือ',
          key: 'sumBalance',
          dataIndex: 'sumBalance',
          scopedSlots: { customRender: 'sumBalance' },
          width: 120,
        },
      ],
      brokenColumns: [
        {
          title: 'รหัสธุรกรรม',
          key: 'bankPaymentId',
          dataIndex: 'bankPaymentId',
          sorter: (a, b) => moment(a.bankPaymentId).unix() - moment(b.bankPaymentId).unix(),
        },
        // {
        //   title: "ยอดเติมเงิน",
        //   dataIndex: "sumBankPaymentDeposit",
        //   key: "sumBankPaymentDeposit",
        //   filters: [
        //     { text: "บัญชีรับ", value: 1 },
        //     { text: "บัญชีถอน", value: 2 },
        //     { text: "บัญชีถอนคืนลูกค้า", value: 3 },
        //     { text: "บัญชีถอนคอมมิชชั่น", value: 4 },
        //   ],
        //   onFilter: (value, record) =>
        //     record.bankServiceType.toString().includes(value.toString()),
        //   width: 120,
        //   scopedSlots: { customRender: "bankType" },
        // },
        {
          title: 'ยอดเติมเงิน',
          key: 'amountInCome',
          dataIndex: 'amountInCome',
          scopedSlots: { customRender: 'amountInCome' },
        },
        {
          title: 'บัญชีธนาคาร',
          key: 'bankServiceSystem',
          dataIndex: 'bankServiceSystem',
          scopedSlots: { customRender: 'bankServiceSystem' },
        },
        {
          title: 'เวลาโอน',
          key: 'datetimeTranfer',
          dataIndex: 'datetimeTranfer',
          sorter: (a, b) => moment(a.datetimeTranfer).unix() - moment(b.datetimeTranfer).unix(),
          customRender: (text, row, index) => {
            return moment(text).format('YYYY-MM-DD 15:15:00')
          },
        },
        {
          title: 'หมายเหตุ',
          key: 'remark',
          dataIndex: 'remark',
        },
      ],
      columnsStatement: [
        {
          title: 'ลำดับ',
          key: 'bankPaymentId',
          dataIndex: 'bankPaymentId',
          width: 80,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'bankPaymentId',
          },
          onFilter: (value, record) => record.bankPaymentId.toString().includes(value.toString()),
        },
        {
          title: 'ชื่อคู่ค้า',
          key: 'operatorName',
          dataIndex: 'operatorName',
          width: 100,
          filters: [],
          onFilter: (value, record) => record.operatorName.toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: 'บัญชีระบบ',
          key: 'bankServiceSystem',
          dataIndex: 'bankServiceSystem',
          width: 150,
        },
        {
          title: 'เวลาโอน',
          key: 'datetimeTranfer',
          dataIndex: 'datetimeTranfer',
          sorter: (a, b) => { return new Date(a.datetimeTranfer) - new Date(b.datetimeTranfer) },
          customRender: (text, row, index) => {
            return momentTz(text).tz('utc').format('DD/MM/YYYY HH:mm:ss')
          },
          width: 150,
        },
        {
          title: 'เงินเข้า',
          key: 'amountInCome',
          dataIndex: 'amountInCome',
          sorter: (a, b) => a.amountInCome - b.amountInCome,
          scopedSlots: { customRender: 'actionAmountInCome' },
          // customRender: (text, row, index) => {
          //   if (text !== '-') {
          //     const amountIncomes = parseFloat(text)
          //     return amountIncomes.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          //   }
          //   return text
          // },
          width: 100,
        },
        {
          title: 'เงินออก',
          key: 'amountOutCome',
          dataIndex: 'amountOutCome',
          scopedSlots: { customRender: 'actionAmountOutCome' },
          // customRender: (text, row, index) => {
          //   if (text !== '-') {
          //     const amountOutComes = parseFloat(text)
          //     return amountOutComes.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          //   }
          //   return text
          // },
          width: 100,
        },
        {
          title: 'รายละเอียด',
          key: 'detail',
          dataIndex: 'detail',
          scopedSlots: {
            customRender: 'detail',
          },
          width: 100,
        },
        {
          title: 'สถานะ',
          filters: [],
          onFilter: (value, record) => record.filtersStatus.toString().includes(value.toString()),
          // onFilter: (value, record) => record.filtersStatus.toString().includes(value.toString()),
          key: 'status',
          dataIndex: 'bankPaymentStatus',
          scopedSlots: {
            customRender: 'status',
          },
          width: 130,
          fixed: 'right',
        },
        {
          title: 'ธนาคารที่โอน',
          key: 'detailBankNumber',
          dataIndex: 'detailBankNumber',
          width: 250,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'detailBankNumber',
          },
          onFilter: (value, record) => record.detailBankNumber.toLowerCase().includes(value.toLowerCase()),
          fixed: 'right',
        },
        {
          title: 'วันที่สร้าง',
          key: 'createdAt',
          dataIndex: 'createdAt',
          width: 100,
          customRender: (text, row, index) => {
            return momentTz(text).tz('utc').format('DD/MM/YYYY HH:mm:ss')
          },
          fixed: 'right',

        },
        {
          title: 'วันที่อัปเดท',
          key: 'updatedAt',
          dataIndex: 'updatedAt',
          width: 100,
          customRender: (text, row, index) => {
            return momentTz(text).tz('utc').format('DD/MM/YYYY HH:mm:ss')
          },
          fixed: 'right',

        },
      ],
      columnsSumDef: [
        {
          title: 'ประเภท',
          key: 'type',
          dataIndex: 'type',
          width: 120,
          customRender: (text, row, index) => {
            const result =
              text === 'total'
                ? 'รวม'
                : text === 'deposit'
                  ? 'ยอดขาด'
                  : text === 'withdraw'
                    ? 'ยอดเกิน'
                    : 'ไม่พบข้อมูล'
            return result
          },
        },
        {
          title: 'ยอดเติมเงิน',
          key: 'sumDeposit',
          dataIndex: 'sumDeposit',
          width: 120,
        },
        {
          title: 'ยอดเติมเงินQR',
          key: 'sumDepositQR',
          dataIndex: 'sumDepositQR',
          width: 120,
        },
        {
          title: 'ยอดรวมเติมเงิน',
          key: 'sumDepositTotal',
          dataIndex: 'sumDepositTotal',
          width: 120,
        },
        {
          title: 'ยอดถอนเงิน',
          key: 'sumWithdraw',
          dataIndex: 'sumWithdraw',
          width: 120,
        },
      ],
      endOpen: false,
      endOpenStatement: false,
      columnTotal: [
        {
          title: 'ยอดเติมเงิน',
          key: 'deposit',
          dataIndex: 'deposit',
          align: 'center',
          customRender: (text, row, index) => {
            return this.setComma(text)
          },
        },
        {
          title: 'ยอดถอน',
          key: 'withdraw',
          dataIndex: 'withdraw',
          align: 'center',
          customRender: (text, row, index) => {
            return this.setComma(text)
          },
        },
      ],
      spinning: false,
      delayTime: 500,
      isLoading: false,
      isLoadingSumReport: false,
      isLoadingStatement: false,
      dataTable: [],
      dataSumDef: [],
      dataDefDeposit: [],
      dataDefDepositQR: [],
      dataDefWithdraw: [],
      dataTotal: [],
      dataExport: [],
      dataExporReport: [],
      operator: [],
      selectedRowKeys: [],
      selectedRowKeysReport: [],
      json_data: [],
      json_data_report: [],
      dataReports: [],
      dataStatement: [],
      dataBroken: [],
      dataOver: [],
      form: {
        date: '',
        operatorCode: '',
      },
      rules: {
        date: [{ required: true, message: 'กรุณาวันที่', trigger: 'blur' }],
        operatorCode: [
          { required: true, message: 'กรุณาเลือกคู่ค้า', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    getNameExport() {
      return 'รายงานสรุปบัญชี'
    },
    getNameExportReport() {
      return 'สรุปรายงาน'
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    onSelectChangeReport(selectedRowKeysReport) {
      this.selectedRowKeysReport = selectedRowKeysReport
    },
    setComma(value) {
      // console.log(value)
      if (value !== null && typeof value !== 'undefined') {
        return value.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      } else {
        return 0.0
      }
    },
    setCommaString(value) {
      if (value > 0 && value !== null) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else {
        return '-'
      }
    },
    setColor(value) {
      if (value === 'Deposit') {
        return 'color: #14ab84'
      } else if (value === 'Yellow') {
        return 'color: #FFE807'
      } else if (value === 'Orange') {
        return 'color: #FFA507'
      } else if (value === 'Light Blue') {
        return 'color: #07E8FF'
      } else if (value === 'Purple') {
        return 'color: #8B00FF'
      } else if (value === 'Pink') {
        return 'color: #FF00EC'
      } else {
        return 'color: #f04e3f'
      }
    },
    setColorAmount(value) {
      if (value === 'amountIn') {
        return 'color: #14ab84'
      } else {
        return 'color: #f04e3f'
      }
    },
    async getDataReport() {
      const dataReport = await {
        startDate: this.getStartDate,
        endDate: this.getEndDate,
        operatorCode: this.getSelectOperator,
      }

      this.isLoading = !this.isLoading
      await apiClient
        .post('/reportBankPayment/getData', dataReport)
        .then((response) => {
          this.isLoading = !this.isLoading
          const res = response.data
          if (res.code === '000') {
            this.dataTable = res.responseData.data
            this.exportAll(res.responseData.data)
          }
        })
    },
    getModelMange() {
      this.clearForm()
      this.modelMange = !this.modelMange
      // apiClient.get('/system/getOperator').then(res => {
      //   if (res.data.code === '000') {
      //     this.operator = []
      //     this.operator = res.data.responseData.data
      //     this.modelMange = !this.modelMange
      //   }
      // }).catch(error => {
      //   Swal.showValidationMessage(
      //     `เกิดข้อผิดพลาด: ${error}`,
      //   )
      // })
    },
    useModalMange() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          Swal.fire({
            title: 'Please Wait !',
            showConfirmButton: false,
            onOpen: function () {
              Swal.showLoading()
            },
          })
          this.form.date = moment(this.form.date).format('YYYY-MM-DD')
          return apiClient
            .post('reportBankPayment/calculateReport', this.form)
            .then((response) => {
              const iconError =
                response.data.code === '000' ? 'success' : 'error'
              Toast.fire({
                icon: iconError,
                title: response.data.message,
              })
              this.modelMange = !this.modelMange
            })
            .catch((error) => {
              Swal.showValidationMessage(`เกิดข้อผิดพลาด: ${error}`)
            })
        }
      })
    },
    setOperator(value, option) {
      value = this.operator[option.key].operatorCode
      this.getDataBankService(value)
    },
    getDataBankService(operatorCode) {
      const bankType =
        this.withdrawType === 'default'
          ? 2
          : this.withdrawType === 'refund'
            ? 3
            : this.withdrawType === 'commission'
              ? 4
              : this.withdrawType === 'atm'
                ? 5
                : 1
      apiClient
        .get(`/bankService/getDataBankService/${operatorCode}/${bankType}`)
        .then((res) => {
          if (res.data.code === '000') {
            this.getBankService = []
            this.getBankService = res.data.responseData.data
          }
        })
        .catch((error) => {
          Swal.showValidationMessage(`เกิดข้อผิดพลาด: ${error}`)
        })
    },
    clearForm() {
      this.form = {
        date: '',
        operatorCode: '',
      }
    },
    dataToExcel(data) {
      if (data.length > 0) {
        const dataresult = []
        data.map((result) => {
          // eslint-disable-next-line no-const-assign
          let pushData = {}
          const item = this.dataTable.find((dataResult) => {
            if (dataResult.bankServiceId === result) {
              return true
            }
          })
          pushData = {
            bankServiceName: item.bankServiceName,
            bankServiceType:
              item.bankServiceType === 1
                ? 'บัญชีรับ'
                : item.bankServiceType === 2
                  ? 'บัญชีถอน'
                  : item.bankServiceType === 3
                    ? 'บัญชีถอนคืนลูกค้า'
                    : item.bankServiceType === 4
                      ? 'บัญชีถอนคอมมิชชั่น'
                      : item.bankServiceType === 99
                        ? ''
                        : 'ไม่พบข้อมูล',
            lastSumBalance: item.lastSumBalance,
            bankPaymentDeposit: item.bankPaymentDeposit,
            bankPaymentWithdraw: item.bankPaymentWithdraw,
            TranferDeposit: item.TranferDeposit,
            TranferWithdraw: item.TranferWithdraw,
            TranferDepositManual: item.TranferDepositManual,
            TranferWithdrawManual: item.TranferWithdrawManual,
            depositReserveWithdrawal: item.depositReserveWithdrawal,
            withdrawBankCenter: item.withdrawBankCenter,
            withdrawCustomer: item.withdrawCustomer,
            customerDepositFalse: item.customerDepositFalse,
            interest: item.interest,
            entryFee: item.entryFee,
            depositNotSpecified: item.depositNotSpecified,
            withdrawNotSpecified: item.withdrawNotSpecified,
            sumBalance: item.sumBalance,
          }
          dataresult.push(pushData)
        })
        this.json_data = dataresult
      }
    },
    exportAll(obj) {
      this.dataExport = []
      let resultData = {}
      obj.map((item) => {
        resultData = {
          bankServiceName: item.bankServiceName,
          bankServiceType:
              item.bankServiceType === 1
                ? 'บัญชีรับ'
                : item.bankServiceType === 2
                  ? 'บัญชีถอน'
                  : item.bankServiceType === 3
                    ? 'บัญชีถอนคืนลูกค้า'
                    : item.bankServiceType === 4
                      ? 'บัญชีถอนคอมมิชชั่น'
                      : item.bankServiceType === 99
                        ? ''
                        : 'ไม่พบข้อมูล',
          lastSumBalance: item.lastSumBalance,
          bankPaymentDeposit: item.bankPaymentDeposit,
          bankPaymentWithdraw: item.bankPaymentWithdraw,
          TranferDeposit: item.TranferDeposit,
          TranferWithdraw: item.TranferWithdraw,
          TranferDepositManual: item.TranferDepositManual,
          TranferWithdrawManual: item.TranferWithdrawManual,
          depositReserveWithdrawal: item.depositReserveWithdrawal,
          withdrawBankCenter: item.withdrawBankCenter,
          withdrawCustomer: item.withdrawCustomer,
          customerDepositFalse: item.customerDepositFalse,
          interest: item.interest,
          entryFee: item.entryFee,
          depositNotSpecified: item.depositNotSpecified,
          withdrawNotSpecified: item.withdrawNotSpecified,
          sumBalance: item.sumBalance,
        }
        this.dataExport.push(resultData)
      })
    },
    onError: function (e) {
      Toast.fire({ icon: 'error', title: 'Failed to copy texts' })
    },
    onCopy: function (e) {
      const dataJson = JSON.parse(e.text)
      let row = ''
      if (dataJson.length > 0) {
        dataJson.map((result) => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataTable.find((dataResult) => {
            if (dataResult.bankServiceId === result) {
              return true
            }
          })
          const resultData = {
            bankServiceName: item.bankServiceName,
            bankServiceType:
              item.bankServiceType === 1
                ? 'บัญชีรับ'
                : item.bankServiceType === 2
                  ? 'บัญชีถอน'
                  : item.bankServiceType === 3
                    ? 'บัญชีถอนคืนลูกค้า'
                    : item.bankServiceType === 4
                      ? 'บัญชีถอนคอมมิชชั่น'
                      : item.bankServiceType === 99
                        ? ''
                        : 'ไม่พบข้อมูล',
            lastSumBalance: item.lastSumBalance,
            bankPaymentDeposit: item.bankPaymentDeposit,
            bankPaymentWithdraw: item.bankPaymentWithdraw,
            TranferDeposit: item.TranferDeposit,
            TranferWithdraw: item.TranferWithdraw,
            TranferDepositManual: item.TranferDepositManual,
            TranferWithdrawManual: item.TranferWithdrawManual,
            depositReserveWithdrawal: item.depositReserveWithdrawal,
            withdrawBankCenter: item.withdrawBankCenter,
            withdrawCustomer: item.withdrawCustomer,
            customerDepositFalse: item.customerDepositFalse,
            interest: item.interest,
            entryFee: item.entryFee,
            depositNotSpecified: item.depositNotSpecified,
            withdrawNotSpecified: item.withdrawNotSpecified,
            sumBalance: item.sumBalance,
          }
          const convertObj = Object.values(resultData)
          const col = convertObj.join(' \t ')
          row += `${col} \n`
        })
        // this.clipboard(row)
        CopyMe(row)
        Toast.fire({ icon: 'success', title: 'success copy' })
      } else {
        Toast.fire({
          icon: 'error',
          title: 'กรุณาเลือกข้อมูลที่ต้องการคัดลอก',
        })
      }
    },
    dataToExcelReport(data) {
      if (data.length > 0) {
        const dataresult = []
        data.map((result) => {
          // eslint-disable-next-line no-const-assign
          let pushData = {}
          const item = this.dataReports.find((dataResult) => {
            if (dataResult.sumReportDate === result) {
              return true
            }
          })
          pushData = {
            sumReportDate: item.sumReportDate,
            sumBankPaymentDeposit: item.sumBankPaymentDeposit,
            overDeposit: item.overDeposit,
            brokenDeposit: item.brokenDeposit,
            customerDepositFalse: item.customerDepositFalse,
            sumTotalDeposit: item.sumTotalDeposit,
            depositReserveWithdrawal: item.depositReserveWithdrawal,
            sumBankPaymentWithdraw: item.sumBankPaymentWithdraw,
            overWithdraw: item.overWithdraw,
            brokenWithdraw: item.brokenWithdraw,
            sumWithdrawCustomer: item.sumWithdrawCustomer,
            sumTotalWithdraw: item.sumTotalWithdraw,
            TranferDeposit: item.TranferDeposit,
            TranferWithdraw: item.TranferWithdraw,
            TranferDepositManual: item.TranferDepositManual,
            TranferWithdrawManual: item.TranferWithdrawManual,
            withdrawBankCenter: item.withdrawBankCenter,
            depositNotSpecified: item.depositNotSpecified,
            withdrawNotSpecified: item.withdrawNotSpecified,
            interest: item.interest,
            sumWithdrawJackport: item.sumWithdrawJackport,
            sumWithdrawJackportManual: item.sumWithdrawJackportManual,
            sumBalance: item.sumBalance,
          }
          dataresult.push(pushData)
        })
        this.json_data_report = dataresult
      }
    },
    exportAllReport(obj) {
      this.dataExporReport = []
      let resultData = {}
      obj.map((item) => {
        resultData = {
          sumReportDate: item.sumReportDate,
          sumBankPaymentDeposit: item.sumBankPaymentDeposit,
          overDeposit: item.overDeposit,
          brokenDeposit: item.brokenDeposit,
          customerDepositFalse: item.customerDepositFalse,
          sumTotalDeposit: item.sumTotalDeposit,
          depositReserveWithdrawal: item.depositReserveWithdrawal,
          sumBankPaymentWithdraw: item.sumBankPaymentWithdraw,
          overWithdraw: item.overWithdraw,
          brokenWithdraw: item.brokenWithdraw,
          sumWithdrawCustomer: item.sumWithdrawCustomer,
          sumTotalWithdraw: item.sumTotalWithdraw,
          TranferDeposit: item.TranferDeposit,
          TranferWithdraw: item.TranferWithdraw,
          TranferDepositManual: item.TranferDepositManual,
          TranferWithdrawManual: item.TranferWithdrawManual,
          withdrawBankCenter: item.withdrawBankCenter,
          depositNotSpecified: item.depositNotSpecified,
          withdrawNotSpecified: item.withdrawNotSpecified,
          interest: item.interest,
          sumWithdrawJackport: item.sumWithdrawJackport,
          sumWithdrawJackportManual: item.sumWithdrawJackportManual,
          sumBalance: item.sumBalance,
        }
        this.dataExporReport.push(resultData)
      })
    },
    onCopyReport: function (e) {
      const dataJson = JSON.parse(e.text)
      let row = ''
      if (dataJson.length > 0) {
        dataJson.map((result) => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataReports.find((dataResult) => {
            if (dataResult.sumReportDate === result) {
              return true
            }
          })
          const resultData = {
            sumReportDate: item.sumReportDate,
            sumBankPaymentDeposit: item.sumBankPaymentDeposit,
            overDeposit: item.overDeposit,
            brokenDeposit: item.brokenDeposit,
            customerDepositFalse: item.customerDepositFalse,
            sumTotalDeposit: item.sumTotalDeposit,
            depositReserveWithdrawal: item.depositReserveWithdrawal,
            sumBankPaymentWithdraw: item.sumBankPaymentWithdraw,
            overWithdraw: item.overWithdraw,
            brokenWithdraw: item.brokenWithdraw,
            sumWithdrawCustomer: item.sumWithdrawCustomer,
            sumTotalWithdraw: item.sumTotalWithdraw,
            TranferDeposit: item.TranferDeposit,
            TranferWithdraw: item.TranferWithdraw,
            TranferDepositManual: item.TranferDepositManual,
            TranferWithdrawManual: item.TranferWithdrawManual,
            withdrawBankCenter: item.withdrawBankCenter,
            depositNotSpecified: item.depositNotSpecified,
            withdrawNotSpecified: item.withdrawNotSpecified,
            interest: item.interest,
            sumWithdrawJackport: item.sumWithdrawJackport,
            sumWithdrawJackportManual: item.sumWithdrawJackportManual,
            sumBalance: item.sumBalance,
          }
          const convertObj = Object.values(resultData)
          const col = convertObj.join(' \t ')
          row += `${col} \n`
        })
        // this.clipboard(row)
        CopyMe(row)
        Toast.fire({ icon: 'success', title: 'success copy' })
      } else {
        Toast.fire({
          icon: 'error',
          title: 'กรุณาเลือกข้อมูลที่ต้องการคัดลอก',
        })
      }
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleStartOpenChangeStatement(open) {
      if (!open) {
        this.endOpenStatement = true
      }
    },
    disabledStartDate(startDate) {
      const endDate = this.endDateReport
      if (!startDate || !endDate) {
        return false
      }
      return startDate.valueOf() > endDate.valueOf()
    },
    disabledStartDateStatement(startDate) {
      const endDate = this.endDateStatement
      if (!startDate || !endDate) {
        return false
      }
      return startDate.valueOf() > endDate.valueOf()
    },
    disabledEndDate(endDate) {
      const startDate = this.startDateReport
      if (!endDate || !startDate) {
        return false
      }
      return startDate.valueOf() > endDate.valueOf()
    },
    disabledEndDateStatement(endDate) {
      const startDate = this.startDateStatement
      if (!endDate || !startDate) {
        return false
      }
      return startDate.valueOf() > endDate.valueOf()
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    },
    handleEndOpenChangeStatement(open) {
      this.endOpenStatement = open
    },
    setOperatorReport() {
      this.setDateReport()
    },
    setOperatorStatement() {
      this.setDateStatement()
    },
    async setDateReport() {
      const startDate = this.startDateReport
        ? this.startDateReport.format('YYYY/MM/DD 00:00:00')
        : moment().format('YYYY/MM/DD 00:00:00')
      const endDate = this.endDateReport
        ? this.endDateReport.format('YYYY/MM/DD 23:59:59')
        : moment().format('YYYY/MM/DD 23:59:59')

      const dataReport = await {
        startDate,
        endDate,
        operatorCode: this.operterReport,
      }
      if (this.operterReport !== '') {
        this.isLoadingSumReport = true

        await apiClient
          .post('/reportBankPayment/getDataSumReport', dataReport)
          .then((response) => {
            const res = response.data
            const data = this.checkSumReportNull(res.responseData.data)
            // res.sumReportDate = this.startDateReport.format('YYYY-MM-DD') +
            //  ' ถึง ' + this.endDateReport.format('YYYY-MM-DD')
            this.dataReports = data
            this.exportAllReport(data)
            this.dataBroken = res.responseData.dataBrokenDeposit
            this.dataOver = res.responseData.dataOverDeposit

            if (this.statusKey === 1) {
              this.columnsBroken[7].filters = [{ text: 'ทำรายการสำเร็จ', value: 1 },
                { text: 'รายการใหม่', value: 2 },
                { text: 'ตรวจสอบจับคู่รายการ', value: 3 },
                { text: 'สร้างมือ', value: 6 },
                { text: 'แนปสลิป', value: 7 },
                { text: 'สร้างมือ/แนปสลิป', value: 8 }]
              this.columnsOver[7].filters = [{ text: 'ทำรายการสำเร็จ', value: 1 },
                { text: 'รายการใหม่', value: 2 },
                { text: 'ตรวจสอบจับคู่รายการ', value: 3 },
                { text: 'สร้างมือ', value: 6 },
                { text: 'แนปสลิป', value: 7 },
                { text: 'สร้างมือ/แนปสลิป', value: 8 }]
            } else {
              this.columnsBroken[7].filters = [{ text: 'รายการมีปัญหา', value: 4 },
                { text: 'รายการผี', value: 5 },
                { text: 'สร้างมือ', value: 9 },
                { text: 'แนปสลิป', value: 10 },
                { text: 'สร้างมือ/แนปสลิป', value: 11 }]
              this.columnsOver[7].filters = [{ text: 'รายการมีปัญหา', value: 4 },
                { text: 'รายการผี', value: 5 },
                { text: 'สร้างมือ', value: 9 },
                { text: 'แนปสลิป', value: 10 },
                { text: 'สร้างมือ/แนปสลิป', value: 11 }]
            }
            // this.sumColumns[0].title = this.startDateReport.format("YYYY-MM-DD")
            //  + " ถึง " + this.endDateReport.format("YYYY-MM-DD")
            this.isLoadingSumReport = false
          })
      }
    },
    async setDateStatement() {
      const startDate = this.startDateStatement
        ? this.startDateStatement.format('YYYY/MM/DD 00:00:00')
        : moment().format('YYYY/MM/DD 00:00:00')
      // const endDate = this.endDateStatement
      //   ? this.endDateStatement.format('YYYY/MM/DD 23:59:59')
      //   : moment().format('YYYY/MM/DD 23:59:59')

      const dataStatement = await {
        startDate,
        operatorCode: this.operterStatement,
      }

      if (this.operterStatement !== '') {
        this.isLoadingStatement = !this.isLoadingStatement
        await apiClient
          .post('/statement/getLikeStatment', dataStatement)
          .then((response) => {
            const res = response.data
            if (res.code === '000') {
              const data = this.checkSumReportNull(res.responseData.data)
              this.dataStatement = data
              if (this.statusKey === 1) {
                this.columnsStatement[7].filters = [{ text: 'ทำรายการสำเร็จ', value: 1 },
                  { text: 'รายการใหม่', value: 2 },
                  { text: 'ตรวจสอบจับคู่รายการ', value: 3 },
                  { text: 'สร้างมือ', value: 6 },
                  { text: 'แนปสลิป', value: 7 },
                  { text: 'สร้างมือ/แนปสลิป', value: 8 }]
              } else {
                this.columnsStatement[7].filters = [{ text: 'รายการมีปัญหา', value: 4 },
                  { text: 'รายการผี', value: 5 },
                  { text: 'สร้างมือ', value: 9 },
                  { text: 'แนปสลิป', value: 10 },
                  { text: 'สร้างมือ/แนปสลิป', value: 11 }]
              }
            }
            this.isLoadingStatement = !this.isLoadingStatement
          })
      }
    },
    loadOperater() {
      apiClient
        .get('/system/getOperator')
        .then((res) => {
          if (res.data.code === '000') {
            this.operator = []
            this.operator = res.data.responseData.data
          }
        })
        .catch((error) => {
          Swal.showValidationMessage(`เกิดข้อผิดพลาด: ${error}`)
        })
    },
    checkSumReportNull: (params) => {
      params.forEach((data, i) => {
        for (const key in data) {
          data[key] = data[key] === null ? 0 : data[key]
          params[i][key] = data[key]
        }
      })

      return params
    },
    getStatus(type, status) {
      return getName(type, status)[0]
    },
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    handleSearch(selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },

  },
  created() {
    this.loadOperater()
  },
}
</script>

<style scoped>
.spin-content {
  border: 0px solid #91d5ff;
  background-color: #fafafa;
  padding: 30px;
}
</style>
